import type { SVGProps } from 'react';

const CloseIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg viewBox="-951 532 17 17" {...props}>
        <path
            id="cross"
            d="M-941.794 540.5l2.646-2.646a.5.5 0 0 0-.707-.707l-2.646 2.646-2.646-2.646a.5.5 0 0 0-.707.707l2.646 2.646-2.646 2.646a.5.5 0 0 0 .708.707l2.646-2.646 2.646 2.646a.498.498 0 0 0 .708 0 .5.5 0 0 0 0-.707l-2.648-2.646z"></path>
    </svg>
);

export default CloseIcon;
